(() => {
  const lab = document.getElementById('cartivate-mcp');
  if (!lab || lab.dataset.elonReady) return;
  const power = lab.querySelector('#em-power');
  const status = lab.querySelector('#em-status');
  if (!power || !status) return;
  lab.dataset.elonReady = 'true';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let busy = false;
  let started = false;
  let surgeTimer;
  let powerTimer;
  let finishTimer;
  function setPower(on) {
    if (!on) {
      clearTimeout(surgeTimer);
      lab.classList.remove('surging');
    }
    lab.classList.toggle('on', on);
    power.setAttribute('aria-checked', String(on));
    status.textContent = on ? status.dataset.on : status.dataset.off;
  }
  function surge() {
    if (motion.matches) return;
    const button = power.getBoundingClientRect();
    const section = lab.getBoundingClientRect();
    lab.style.setProperty('--surge-x', `${button.left + button.width / 2 - section.left}px`);
    lab.style.setProperty('--surge-y', `${button.top + button.height / 2 - section.top}px`);
    lab.classList.remove('surging');
    void lab.offsetWidth;
    lab.classList.add('surging');
    clearTimeout(surgeTimer);
    surgeTimer = setTimeout(() => lab.classList.remove('surging'), 2800);
  }
  function start() {
    if (busy) return;
    started = true;
    if (motion.matches) { setPower(true); return; }
    busy = true;
    setPower(false);
    lab.classList.add('activating');
    powerTimer = setTimeout(() => { setPower(true); surge(); }, 970);
    finishTimer = setTimeout(() => { lab.classList.remove('activating'); busy = false; }, 2200);
  }
  power.addEventListener('click', () => {
    if (busy) return;
    if (lab.classList.contains('on')) setPower(false);
    else start();
  });
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    clearTimeout(powerTimer);
    clearTimeout(finishTimer);
    clearTimeout(surgeTimer);
    lab.classList.remove('activating', 'surging');
    if (busy) setPower(true);
    busy = false;
  });
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting) && !started) {
      start();
      observer.disconnect();
    }
  }, { threshold: .2 });
  observer.observe(lab.querySelector('.mo-heading'));
})();
